 import { useMemo } from "react";
import { MenuItem } from "../../types/layout/SidebarType";
 import { useParams } from "react-router-dom";
import { useRoles } from "../../context/RolesContext";

const staticRoles = ["organizationadmin", "sales", "developers", "support"];

export const useMenuList = (): MenuItem[] => {
  const { roles } = useRoles();  
  const { role } = useParams<{ role?: string }>();
  const currentRole = role?.toLowerCase();

  return useMemo(
    () => [
      {
        title: "",
        Items: [
          {
            title: "Dashboard",
            id: 2,
            icon: "home",
            type: "link",
            path: `${process.env.PUBLIC_URL}/dashboard`,
            role: "dashboard",
          },
          {
            title: "Master Data",
            id: 1,
            icon: "file",
            type: "sub",
            lanClass: "lan-8",
            role: "master-data",
            children: [
              {
                title: "Organizations",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/masterdata/organization`,
                role: "organization",
              },
              {
                title: "Holidays",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/masterdata/holidays`,
                role: "holidays",
              },
              {
                title: "TaxTypes",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/masterdata/taxtype`,
                role: "taxtype",
              },
              {
                title: "HolidayType",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/masterdata/holiday-type`,
                role: "holiday-type",
              },
              {
                title: "LeaveType",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/masterdata/leave-type`,
                role: "leave-type",
              },
            ],
          },
          {
            title: "Users",
            id: 3,
            icon: "user",
            type: "sub",
            lanClass: "lan-8",
            role: "users",
            children: [
              // Static roles
              {
                title: "organizationAdmin",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/users/organization-admin`,
                role: "organizationadmin",
              },
              {
                title: "Sales",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/users/sales`,
                role: "sales",
              },
              {
                title: "Developers",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/users/developers`,
                role: "developers",
              },
              {
                title: "Support",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/users/support`,
                role: "support",
              },
              // Dynamic roles
              ...roles
                .filter((role) => !staticRoles.includes(role))
                .sort()
                .map((role) => ({
                  title: role.charAt(0).toUpperCase() + role.slice(1),
                  type: "link" as const,
                  lanClass: "lan-4",
                  path: `${process.env.PUBLIC_URL}/users/${role}`,
                  role,
                })),
            ],
          },
          {
            title: "MasterSetting",
            id: 3,
            icon: "knowledgebase",
            type: "sub",
            lanClass: "lan-8",
            role: "master-setting",
            children: [
              {
                title: "AccessRights",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/mastersettings/accessrights`,
                role: "accessrights",
              },
              {
                title: "IPManagement",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/mastersettings/ipsettings`,
                role: "ipsettings",
              },
              {
                title: "SMSGateway",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/mastersettings/smsgateway`,
                role: "smsgateway",
              },
              {
                title: "PaymentGateway",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/mastersettings/paymentgateway`,
                role: "paymentgateway",
              },
              {
                title: "GeneralSettings",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/mastersettings/general-settings`,
                role: "general-settings",
              },
            ],
          },
          {
            title: "BillsPayment",
            id: 2,
            icon: "form",
            type: "link",
            
            children: [{
              title: "Invoice",
              type: "link",
              lanClass: "lan-4",
              path: `${process.env.PUBLIC_URL}/billingpayments/invoice`,
            },
            {
              title: "Receipt",
              type: "link",
              lanClass: "lan-4",
              path: `${process.env.PUBLIC_URL}/billingpayments/reciept`,
              role: "Receipt",
            },]
          },
          {
            title: "Add-On",
            id: 2,
            icon: "form",
            type: "link",
            path: `${process.env.PUBLIC_URL}/addons`,
            role: "addons",
          },

          {
            title: "Communication",
            id: 3,
            icon: "knowledgebase",
            type: "sub",
            lanClass: "lan-8",
             children: [
              {
                title: "Email",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/communication/email`,
              },
              {
                title: "SMS",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/communication/sms`,
              },
              {
                title: "PushNotification",
                type: "link",
                lanClass: "lan-4",
                path: `${process.env.PUBLIC_URL}/communication/push-notification`,
              },
            ],
          },

          


          {
            title: "Reports",
            id: 3,
            icon: "charts",
            type: "link",
            path: `${process.env.PUBLIC_URL}/reports`,
            role: "reports",
          },
       
        ],
      },
    ],
    [roles, currentRole]
  );
};